import React, { useState } from 'react';
import { ReactComponent as ApiIcon } from '../assets/img/icons/API.svg';
import { ReactComponent as DownloadIcon } from '../assets/img/icons/Download.svg';
import { ReactComponent as PencilIcon } from '../assets/img/icons/Pencil.svg';
import { ReactComponent as ArrowIcon } from '../assets/img/icons/Arrow.svg';
import { ReactComponent as AddUserIcon } from '../assets/img/icons/AddUser.svg';
import { ReactComponent as SearchIcon } from '../assets/img/icons/Search.svg';
import { ReactComponent as CloseIcon } from '../assets/img/icons/Close.svg';
import { ReactComponent as BackArrowIcon } from '../assets/img/icons/ArrowBack.svg';
import { ReactComponent as InfoIcon } from '../assets/img/icons/Info.svg';
import { ReactComponent as ActivateCardIcon } from '../assets/img/icons/ActivateCard.svg';
import { ReactComponent as TransferCSVIcon } from '../assets/img/icons/TransferCSV.svg';
import { ReactComponent as TransferAllIcon } from '../assets/img/icons/TransferAll.svg';
import ReceiptImage from '../assets/img/icons/transactions/receipt-text.png';
import { ReactComponent as PDFIcon } from "../assets/img/icons/pdf.svg";


type Props = {
    type: 'api' | 'download' | 'arrow' | 'pencil' | 'addUser' | 'search' | 'close' | 'backArrow' | 'info' | 'activateCard' | 'transferCSV' | 'transferAll' | 'receipt' | 'pdf',
    children?: React.ReactNode,
    onClick?: () => void,
    className?: string,
    text?: string | React.ReactNode
}

export const Icon: (props: Props) => JSX.Element =
    ({
         type,
         onClick,
         children,
         className,
         text
    }) => {

    const [showTooltip, setShowTooltip] = useState(false);

    let IconSvg;

    switch(type) {
        case 'api':
            IconSvg = ApiIcon;
            break;
        case 'download':
            IconSvg = DownloadIcon;
            break;
        case 'pdf':
            IconSvg = PDFIcon;
            break;
        case 'arrow':
            IconSvg = ArrowIcon;
            break;
        case 'pencil':
            IconSvg = PencilIcon;
            break;
        case 'addUser':
            IconSvg = AddUserIcon;
            break;
        case 'search':
            IconSvg = SearchIcon;
            break;
        case 'close':
            IconSvg = CloseIcon;
            break;
        case 'backArrow':
            IconSvg = BackArrowIcon;
            break;
        case 'info':
            IconSvg = InfoIcon;
            break;
        case 'activateCard':
            IconSvg = ActivateCardIcon;
            break;
        case 'transferCSV':
            IconSvg = TransferCSVIcon;
            break;
        case 'transferAll':
            IconSvg = TransferAllIcon;
            break;
        case 'receipt':
            IconSvg = ReceiptImage;
            break;
        default:
            IconSvg = 'span';
    }

    const IconElement = (
        <IconSvg onClick={(onClick ? onClick : () => {})} className={'' + (className || '')} />
    );

    if (text) {
        return (
            <div className="flex items-center ml-1 relative">
                <IconSvg
                    className="inline-block"
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                />     
                {showTooltip &&
                    <span className="mr-2 rounded shadow-lg p-1 bg-gray-700 text-white text-xs whitespace-nowrap z-10 absolute right-full -top-2">
                        {text}
                    </span>
                }
            </div>
        );
    }

    if (children) {
        return (
            <div className="d-inline-block position-relative">
                {IconElement}
                {children}
            </div>
        );
    }

    return IconElement;
};
